// src/components/donation/DonationDetails.jsx
import { motion } from "framer-motion";
import qrImage from "../../assets/images/donation/qr-code.png"; // Replace with actual QR code image

const DonationDetails = () => {
  return (
    <section id="donate-now" className="bg-white py-20">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.h2
          className="text-3xl md:text-4xl font-bold text-primary font-heading mb-6"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          Make a Difference Today
        </motion.h2>

        <motion.p
          className="text-lg text-gray-700 mb-10 max-w-3xl mx-auto font-body"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.2 }}
        >
          Your donation directly fuels our work in transforming lives through collaboration, education, and innovation.
          Every contribution brings us closer to a better, more equitable future.
        </motion.p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 mt-8">
          {/* Left: Bank Details */}
          <motion.div
            className="bg-gradient-to-br from-blue-50 to-white rounded-2xl shadow-xl p-8 text-left"
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h3 className="text-xl font-bold text-primary mb-4">Bank Transfer Details</h3>
            <ul className="text-gray-800 space-y-3 text-sm font-medium">
              <li><span className="text-secondary">Account Name:</span> Impact Together Foundation</li>
              <li><span className="text-secondary">Bank:</span> ABC Bank</li>
              <li><span className="text-secondary">Account No:</span> 1234567890</li>
              <li><span className="text-secondary">IFSC:</span> ABCD0123456</li>
              <li><span className="text-secondary">Branch:</span> Mumbai Central</li>
              <li><span className="text-secondary">Type:</span> Current Account</li>
            </ul>
          </motion.div>

          {/* Right: QR Code */}
          <motion.div
            className="bg-gradient-to-br from-pink-50 to-white rounded-2xl shadow-xl p-8 flex flex-col items-center justify-center"
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h3 className="text-xl font-bold text-primary mb-4">Scan & Donate</h3>
            <img
              src={qrImage}
              alt="QR Code for Donation"
              className="h-44 w-44 object-contain mb-4 drop-shadow-md"
            />
            <p className="text-gray-600 text-sm">Scan using any UPI-enabled app to contribute.</p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default DonationDetails;
